import { useState, useEffect, useRef, useCallback, Fragment, useContext } from "react";
import style from "./ShareLog.module.scss";
import { v4 } from "uuid";
import { BottomSheet } from "react-spring-bottom-sheet";
import * as YStyled from "../../Styleds";
import LogItem from "../../comm/global/components/LogItem";
import AlbumItem from "../../comm/global/components/AlbumItem";
import FriendsIcon from "../../comm/global/components/FriendsIcon";
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
import MyBottomSheet from "../../comm/global/components/MyBottomSheet";
const ShareLog = ({ arg, addModalType, setModalType }) => {
  const [isOpen, set_isOpen] = useState(true);
  const [page, set_page] = useState("main");
  const [friends, set_friends] = useState([]);
  const [targetEventId, set_targetEventId] = useState(null);
  const [eventParticipants, set_eventParticipants] = useState([]);
  const [events, set_events] = useState([]);
  const [albums, set_albums] = useState([]);
  const { preProcessEvent, set_tempEvent, tempEvent, userData } = useContext(GameContext);
  useEffect(() => {
    set_isOpen(true);
    apiManager.fetchGet(`user/friends`, {}, 0).then(res => {
      console.log("res", res)
      set_friends(res);
    })

    fetchAllEvents();


    if (arg.defaultOpenAlbumId) {
      set_page("page2");
      arg.viewAlbumOnMap();
    }
  }, [])
  const fetchAllEvents = async () => {
    try {
      // 對每個 rewild 資料執行 fetchGet
      const allEventsPromises = arg.rewild.map(item =>
        apiManager.fetchGet(`collaborative-log`, { rewilding_id: item.achievement_released_id }, 0)
      );

      // 使用 Promise.all 等待所有請求完成
      const allEventsResults = await Promise.all(allEventsPromises);

      // 將所有的 event 集中在一起並處理
      const processEvents = async () => {
        const __events = await Promise.all(allEventsResults.flat().map(async (event) => {
          return await preProcessEvent(event);
        }));
        set_events(__events);
      };
      processEvents();
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };


  useEffect(() => {
    if (isOpen === false) {
      arg.closeCb();
      setModalType(prev => prev.filter(v => v.cls !== "ShareLog"))
    }
  }, [isOpen])
  useEffect(() => {
    if (page === "page2") {
      console.log("userData", userData.users_id);
      updateAlbum();
    }
  }, [page]);
  function updateAlbum() {
    apiManager.fetchGet(`collaborative-log/${tempEvent.events_id}/album-link`, {}, 0).then(res => {
      console.log("res", res, userData);
      set_albums(res);
    })
  }
  function addNewAlbum(url) {
    apiManager.fetchPost(`collaborative-log/${tempEvent.events_id}/album-link`, {
      "event_album_link_album_url": url,
      "event_album_link_visibility": 1
    }, 0).then(res => {
      console.log("res", res);
      updateAlbum();
    }).catch(err => {
      alert(err)
    })
  }
  function editNewAlbum(album, url) {
    apiManager.fetchPut(`collaborative-log/${tempEvent.events_id}/album-link/${album.event_album_link_id}`, {
      "event_album_link_album_url": url,
      "event_album_link_visibility": 1
    }, 0).then(res => {
      console.log("res", res);
      updateAlbum();
    })
  }
  function getCurrentEvent() {
    return events.find(v => v.events_id === targetEventId);
  }
  return (
    <MyBottomSheet canDrag={true} zIndex={1000} display={true} percentY={[0, 1]} cbY={_y => {
      if (_y > 90) {
        set_isOpen(false);
      }
    }}
      content={<div className={style.app}>
        <div className={style.header}>
          <div className={style.bar} />
        </div>
        {
          page === "main" &&
          <div className={style.main} >
            <YStyled.Span size={20} fontFamily="SF Pro">{`${arg.name}的共享日誌`}</YStyled.Span>
            <div className={style.list} >
              {
                events.map((v, k) => {
                  return <LogItem key={k} title={v.events_name} date={v.events_date.formatYYYYMMDD2()} point={v.rewildingObj?.rewilding_name} peoples={v.events_participants.latest_tree_user} cb={e => {
                    set_page("page2");
                    set_tempEvent(v);
                    set_targetEventId(v.events_id);
                    apiManager.fetchGet(`event/${v.events_id}/participants`, {}, 0).then(res => {
                      set_eventParticipants(res);
                    })
                    arg.viewAlbumOnMap(v);
                  }} />
                })
              }
            </div>
            {arg.closeBtn &&
              <img className={style.closeBtn} onClick={async (e) => {
                set_isOpen(false);
              }} src="./assets/ui/closeBtn.png" />
            }
          </div>
        }
        {
          (page === "page2") &&
          <div className={style.page2} >
            <div className={style.info} >
              <YStyled.Row gap=".6rem" align="flex-start" onClick={async (e) => {
                set_page("main")
              }}>
                <img className={style.backBtn} src="./assets/ui/leftArrow.png" />
                <YStyled.Span size={20} fontFamily="SF Pro">{getCurrentEvent().events_name}</YStyled.Span>
              </YStyled.Row>
              <FriendsIcon type="add" addModalType={addModalType} users={getCurrentEvent().events_participants.latest_tree_user} onAdd={() => {
                console.log("friends", friends);
                const participantsId = eventParticipants.map(v => v.event_participants_user_detail.user_id);
                //
                console.log("participantsId", participantsId);
                const filterFriend = friends.reduce((acc, v) => {
                  if (!participantsId.includes(v.user_friends_detail.user_id)) {
                    acc.push(v.user_friends_detail);
                  }
                  return acc;
                }, []);

                console.log("filterFriend", filterFriend)
                addModalType({
                  cls: "AddMember", arg: {
                    users: filterFriend,
                    eventVo: getCurrentEvent(),
                    onAdd: selFriends => {
                      console.log(selFriends);
                      set_isOpen(false);
                      /* apiManager.fetchPost(`event/${arg.vo.events_id}/participants`, {
                        "event_participants_user": userData.users_id
                      }, 0).then(res => {
                        console.log(res);
                      }).catch(err => {
                        console.log(err)
                      }) */
                    }
                  }
                })
              }} />
              <YStyled.Span color="#007AFF" size={15} fontFamily="SF Pro" style={{ alignSelf: "flex-end" }} onClick={e => {
                addModalType({
                  cls: "EventDetail", arg: {
                    cb: () => {
                    },
                    vo: getCurrentEvent(),
                    set_events: set_events,
                  }
                })
              }}>查看行程內容</YStyled.Span>
              <YStyled.Span size={17} fontFamily="SF Pro">所有成員的相簿</YStyled.Span>
            </div>
            <div className={style.list}>
              <AlbumItem onAdd={e => {
                addModalType({
                  cls: "AddLink", arg: {
                    type: "album",
                    title: "新增相簿連結 ",
                    cb: (url) => {
                      addNewAlbum(url);
                    }
                  }
                })
              }} />
              {albums.map((v, k) => {
                return <AlbumItem key={k} album={v} userData={userData} onEdit={e => {
                  addModalType({
                    cls: "AddLink", arg: {
                      type: "album",
                      title: "編輯相簿連結 ",
                      cb: (url) => {
                        editNewAlbum(v, url);
                      }
                    }
                  })
                }} />
              })}
            </div>

            {/* <div className={style.info} >
            <YStyled.Row style={{ alignItems: "center", marginTop: "1rem" }}>
              <YStyled.Span size={17} fontFamily="SF Pro">問卷</YStyled.Span>
              <YStyled.Span color="#007AFF" onClick={e => {
                addModalType({
                  cls: "AddLink", arg: {
                    type: "annketo",
                    cb: res => {

                    }
                  }
                })
              }} size={15} fontFamily="SF Pro" >編輯</YStyled.Span>
            </YStyled.Row>

            {
              hasAnnketo ?
                <div className={style.doAnnketo} onClick={e => {
                }} >
                  <div className={style.imgbox}>
                    <img src="./assets/ui/annketo.png" />
                  </div>
                  <YStyled.Row style={{ alignItems: "center", padding: "0 .4rem 1rem .4rem" }}>
                    <YStyled.Span size={15} fontWeight={400}>森林療癒活動滿意度調查</YStyled.Span>
                    <YStyled.Span onClick={e => { }} size={15} fontFamily="SF Pro" >填寫</YStyled.Span>
                  </YStyled.Row>
                </div>
                :
                <div className={style.annketo} onClick={e => {
                  addModalType({
                    cls: "AddLink", arg: {
                      type: "annketo",
                      cb: res => {
                        set_hasAnnketo(true)
                        addModalType({
                          cls: "AlertCustom", arg: {
                            type: 2,
                            title: "我們暫時不支援此類型的問卷連結",
                            desc1: "目前支援的有：",
                            desc2: "Google 表單, SurveyCake",
                            options: [
                              {
                                label: "返回", color: "black", cb: () => {
                                }
                              }
                            ],
                          }
                        })
                      }
                    }
                  })
                }} >
                  <img src="./assets/ui/annketo.png" />
                  <YStyled.Span size={13} fontWeight={400} fontFamily="SF Pro">新增問卷連結</YStyled.Span>
                </div>
            }

          </div> */}
          </div>
        }
      </div>} />
  );
}

export default ShareLog;